import { marketingGame } from './marketingGame'
import { coupon } from './coupon'
import { editStoreInfo } from './editStoreInfo'
import { delivery } from './delivery'
import { digitalFree } from './digitalFree'
import { groupBuy } from './groupBuy'

export const digitalMarketing = [
  ...marketingGame, // 营销玩法
  ...coupon, // 优惠券
  ...editStoreInfo,
  ...delivery, // 三方配送
  ...digitalFree, // 经营助手全量免费
  ...groupBuy, // 接龙团购
  {
    path: '/digitalMarketing',
    name: 'digitalMarketing',
    component: () => import('views/digitalMarketing'),
    meta: {
      title: '营销中心'
    }
  }
]
